import React, { useEffect, useState } from 'react';
import { Avatar, Box, Button, Card, Checkbox, Chip, Divider, FormControlLabel, Grid, ListItemText, MenuItem, TextField, Typography } from '@material-ui/core';
import GridContainer from '@jumbo/components/GridContainer';
import AppTextInput from '@jumbo/components/Common/formElements/AppTextInput';
import makeStyles from '@material-ui/core/styles/makeStyles';
import CmtImage from '@coremat/CmtImage';
import { useDispatch, useSelector } from 'react-redux';
import { green } from '@material-ui/core/colors';
import { useHistory } from 'react-router';
import Swal from 'sweetalert2';
import UploadPosterDropZone from './UploadPoster/UploadPosterDropZone';
import { createMovieRoot, deleteMovieRoot, duplicateMovieRoot, findProfessions, updateMoviePoster, updateMovieRoot } from 'redux/actions/Movies';
import AppSelectBox from '@jumbo/components/Common/formElements/AppSelectBox';
import { Autocomplete } from '@material-ui/lab';
import CmtAvatar from '@coremat/CmtAvatar';
import { FileCopyTwoTone } from '@material-ui/icons';

const movieTypes = [
    { name: 'فیلم سینمایی', value: 'cinema' },
    { name: 'فیلم کوتاه', value: 'short' },
    { name: 'هنر و تجربه', value: 'honar_tajrobe' },
    { name: 'فیلم خارجی', value: 'foreign_cinema' },
    { name: 'سریال خانگی', value: 'home_serial' },
    { name: 'سریال تلویزیون', value: 'tv_serial' },
    { name: 'سریال خارجی', value: 'foreign_serial' },
    { name: 'اپیزود', value: 'episode' },
];

const useStyles = makeStyles(theme => ({
    cardRoot: {
        padding: 20,
        marginBottom: 10,
        backgroundColor: '#EFF1FB4D',
    },
    qualityCard: {
        padding: 20,
        backgroundColor: '#C0C5F033',
    },
    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -6,
        marginLeft: -15,
    },
    wrapper: {
        margin: theme.spacing(1),
        position: 'relative',
    },
}));


const CreateRootMovieForm = ({ movieInfo }) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const history = useHistory();

    const { posterProps, professionProfile, genresList, professions } = useSelector(({ movies }) => movies);

    const [name, setName] = useState('');
    const [summary, setSummary] = useState('');
    const [engName, setEngName] = useState('');
    const [published, setPublished] = useState(false);
    const [voting, setVoting] = useState(false);
    const [duration, setDuration] = useState('');
    const [publishedYear, setPublishedYear] = useState('');
    const [createYear, setCreateYear] = useState('');
    const [sales, setSales] = useState('');
    const [selectedMovieType, setSelectedMovieType] = useState('');

    const [selectedDirectors, setSelectedDirectors] = useState([]);
    const [selectedActors, setSelectedActors] = useState([]);
    const [selectedProducers, setSelectedProducers] = useState([]);
    const [selectedWriters, setSelectedWriters] = useState([]);
    const [selectedGenre, setSelectedGenre] = useState([]);
    const [selectedOthers, setSelectedOthers] = useState([{ user: null, profession: null }]);

    const [uploadLoading, setUploadLoading] = useState(false);

    const [duplicateNumber, setDuplicateNumber] = useState(1);
    const [duplicateLoading, setDuplicateLoading] = useState(false);

    const handleAddField = () => {
        setSelectedOthers([...selectedOthers, { user: null, profession: null }]);
    };

    const handleSearchProfessions = name => {
        dispatch(findProfessions(name));
    };

    const handleChangeOtherCasts = (index, field, newValue) => {
        const updatedValues = [...selectedOthers];
        updatedValues[index][field] = newValue;
        setSelectedOthers(updatedValues);
    };

    const handleUpload = () => {
        if (posterProps && movieInfo) {
            setUploadLoading(true);

            dispatch(updateMoviePoster({ posterData: posterProps, movieId: movieInfo.uid, setUploadLoading }))
        } else {
            Swal.fire('خطا', 'فیلم انتخابی یا پوستر مورد نظر درست وارد نشده است', 'error');
        }
    };

    const handleSubmit = () => {
        const selectedOthersWithUserId = selectedOthers.filter(other => other.user?.uid);

        const mergedData = {
            story: summary,
            sale: sales,
            produce_year: createYear,
            show_time: publishedYear,
            name: name,
            eng_name: engName,
            in_play: published ? 'inPlay' : 'notPlay',
            allow_vote: voting ? 'allowVote' : 'notAllow',
            duration: duration,
            movie_type: selectedMovieType,
            casts: [
                selectedDirectors.length > 0 ? selectedDirectors.flatMap(director => ({
                    user_uid: director?.uid ? director?.uid : director?.user?.uid,
                    profession_id: 1
                })) : null,
                selectedWriters.length > 0 ? selectedWriters.flatMap(writer => ({
                    user_uid: writer?.uid ? writer?.uid : writer?.user?.uid,
                    profession_id: 2
                })) : null,
                selectedActors.length > 0 ? selectedActors.flatMap(actor => ({
                    user_uid: actor?.uid ? actor?.uid : actor?.user?.uid,
                    profession_id: 3
                })) : null,
                selectedProducers.length > 0 ? selectedProducers.flatMap(producer => ({
                    user_uid: producer?.uid ? producer?.uid : producer?.user?.uid,
                    profession_id: 4
                })) : null,
                selectedOthersWithUserId.length > 0 ? selectedOthersWithUserId.flatMap(other => ({
                    user_uid: other.user?.uid,
                    profession_id: other.profession?.id
                })) : null
            ].filter(Boolean).flat(),
            genre: selectedGenre.map(genre => genre.id) || []
        };
        if (movieInfo?.uid) {
            // Update existing movie
            dispatch(updateMovieRoot(mergedData, movieInfo.uid))
        } else {
            // Create new movie
            dispatch(createMovieRoot({ movieData: mergedData, history, posterProps, setUploadLoading }))
        }
    };

    const handleDelete = () => {
        Swal.fire({
            title: `آیا از حذف ${name} مطمعن هستید؟`,
            icon: 'warning',
            iconHtml: '؟',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'حذف',
            cancelButtonText: 'لغو',
            showCancelButton: true,
            showCloseButton: true,
            preConfirm: () => {
                dispatch(deleteMovieRoot(movieInfo.uid))
                history.push('/movie')
            },
        });
    }

    const handleDuplicateMovie = () => {
        setDuplicateLoading(true);
        Swal.fire({
            title: `آیا از کپی کردن ${name} به تعداد ${duplicateNumber} مطمعن هستید؟`,
            icon: 'info',
            iconHtml: '؟',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'کپی',
            cancelButtonText: 'لغو',
            showLoaderOnConfirm: true,
            showCancelButton: true,
            showCloseButton: true,
            preConfirm: () => {
                dispatch(duplicateMovieRoot({ movieId: movieInfo.id, duplicateNumber: duplicateNumber, movieName: name, setDuplicateLoading }));
            },
            allowOutsideClick: () => !Swal.isLoading()
        })
    }

    useEffect(() => {
        if (movieInfo) {
            setName(movieInfo.movie_name || '');
            setSummary(movieInfo.story || '');
            setEngName(movieInfo.eng_name || '');
            setPublished(movieInfo.in_play === 'inPlay');
            setVoting(movieInfo.allow_vote === 'allowVote');
            setDuration(movieInfo.duration || '');
            setPublishedYear(movieInfo.show_time || '');
            setCreateYear(movieInfo.produce_year || '');
            setSales(movieInfo.sale || '');
            setSelectedMovieType(movieInfo.movie_type || '');
            setSelectedDirectors(movieInfo.casts.directors || '');
            setSelectedWriters(movieInfo.casts.writers || '');
            setSelectedActors(movieInfo.casts.actors || '');
            setSelectedProducers(movieInfo.casts.producers || '');
            setSelectedGenre(movieInfo.genre || '');
            setSelectedOthers(movieInfo.casts.others);
        }
    }, [movieInfo]);


    return (
        <React.Fragment>
            <GridContainer>
                <Grid item xs={12} sm={6}>
                    <CmtImage src={movieInfo?.poster?.large || "https://placehold.co/300x450/png"} />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Card className={classes.cardRoot}>
                        <UploadPosterDropZone />
                        <AppTextInput
                            fullWidth
                            type="text"
                            variant="outlined"
                            value={posterProps?.name}
                            style={{ marginTop: 20 }}
                            disabled
                        />
                        <div className={classes.wrapper}>
                            <Button
                                disabled={uploadLoading || !movieInfo}
                                variant="contained"
                                color="primary"
                                onClick={handleUpload}
                                fullWidth
                                style={{ marginTop: 20 }}>
                                {uploadLoading ? 'درحال آپلود...' : 'تغییر پوستر'}
                            </Button>
                        </div>
                    </Card>
                </Grid>
            </GridContainer>
            <GridContainer style={{ marginBottom: 12 }}>
                <Grid item xs={12} sm={6}>
                    <AppTextInput
                        fullWidth
                        type="text"
                        variant="outlined"
                        label="نام"
                        value={name}
                        onChange={e => setName(e.target.value)}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <AppTextInput
                        fullWidth
                        type="text"
                        variant="outlined"
                        label="نام انگلیسی"
                        value={engName}
                        onChange={e => setEngName(e.target.value)}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <AppTextInput
                        fullWidth
                        type="text"
                        variant="outlined"
                        label="مدت زمان (دقیقه)"
                        value={duration}
                        onChange={e => setDuration(e.target.value)}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <AppTextInput
                        fullWidth
                        type="text"
                        variant="outlined"
                        label="میزان فروش (عدد)"
                        value={sales}
                        onChange={e => setSales(e.target.value)}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <AppTextInput
                        fullWidth
                        type="text"
                        variant="outlined"
                        label="سال ساخت (میلادی یا شمسی)"
                        value={createYear}
                        onChange={e => setCreateYear(e.target.value)}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <AppTextInput
                        fullWidth
                        type="text"
                        variant="outlined"
                        label="سال نمایش (میلادی یا شمسی)"
                        value={publishedYear}
                        onChange={e => setPublishedYear(e.target.value)}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Autocomplete
                        multiple
                        id="genre-autocomplete"
                        options={genresList}
                        getOptionLabel={option => option.name}
                        value={selectedGenre}
                        onChange={(event, newValue) => {
                            setSelectedGenre(newValue);
                        }}
                        onInputChange={(event, newInputValue) => handleSearchProfessions(newInputValue)}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="outlined"
                                label="ژانر"
                                placeholder="ژانر"
                            />
                        )}
                        renderTags={(value, getTagProps) =>
                            value.map((option, index) => (
                                <Chip
                                    key={index}
                                    label={option.name}
                                    {...getTagProps({ index })}
                                />
                            ))
                        }
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <AppSelectBox
                        fullWidth
                        data={movieTypes}
                        label="نوع فیلم"
                        valueKey="value"
                        variant="outlined"
                        labelKey="name"
                        value={selectedMovieType}
                        onChange={e => setSelectedMovieType(e.target.value)}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <AppTextInput
                        multiline
                        minRows={6}
                        fullWidth
                        type="text"
                        variant="outlined"
                        label="خلاصه داستان"
                        value={summary}
                        onChange={e => setSummary(e.target.value)}
                    />
                </Grid>
            </GridContainer>
            <GridContainer style={{ marginBottom: 10 }}>
                <Grid item xs={6} sm={3}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={published}
                                inputProps={{ 'aria-label': 'controlled' }}
                                onChange={event => setPublished(event.target.checked)}
                            />
                        }
                        label="در حال اکران"
                    />
                </Grid>
                <Grid item xs={6} sm={3}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={voting}
                                inputProps={{ 'aria-label': 'controlled' }}
                                onChange={event => setVoting(event.target.checked)}
                            />
                        }
                        label="امکان رای دادن"
                    />
                </Grid>
            </GridContainer>
            <Card className={classes.qualityCard}>
                <Typography variant="h4" component="div" style={{ marginBottom: 25 }}>عوامل فیلم</Typography>
                <GridContainer>
                    <Grid item xs={12} sm={6}>
                        <Autocomplete
                            multiple
                            id="directors-autocomplete"
                            options={professionProfile}
                            getOptionLabel={option => option.fullname ? option.fullname : option.user.fullname}
                            value={selectedDirectors}
                            onChange={(event, newValue) => {
                                setSelectedDirectors(newValue);
                            }}
                            onInputChange={(event, newInputValue) => handleSearchProfessions(newInputValue)}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    label="انتخاب کارگردان‌ها"
                                    placeholder="کارگردان‌ها"
                                />
                            )}
                            renderTags={(value, getTagProps) =>
                                value.map((option, index) => (
                                    <Chip
                                        key={index}
                                        avatar={<Avatar alt={option.fullname ? option.fullname : option?.user?.fullname} src={option.user_img ? option?.user_img : option?.user?.user_img} />}
                                        label={option.fullname ? option.fullname : option.user.fullname}
                                        {...getTagProps({ index })}
                                    />
                                ))
                            }
                            renderOption={(props, option) => {
                                return (
                                    <MenuItem {...props}>
                                        <CmtAvatar size={40} src={props?.user_img ? props?.user_img : props?.user?.user_img} alt={props?.fullname ? props?.fullname : props?.user?.fullname} variant="rounded" />
                                        <ListItemText primary={props?.fullname ? props?.fullname : props?.user?.fullname} style={{ marginRight: 7 }} />
                                    </MenuItem>
                                );
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Autocomplete
                            multiple
                            id="actors-autocomplete"
                            options={professionProfile}
                            getOptionLabel={option => option.fullname ? option.fullname : option.user.fullname}
                            value={selectedActors}
                            onChange={(event, newValue) => {
                                setSelectedActors(newValue);
                            }}
                            onInputChange={(event, newInputValue) => handleSearchProfessions(newInputValue)}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    label="انتخاب بازیگران"
                                    placeholder="بازیگران"
                                />
                            )}
                            renderTags={(value, getTagProps) =>
                                value.map((option, index) => (
                                    <Chip
                                        key={index}
                                        avatar={<Avatar alt={option.fullname ? option.fullname : option.user.fullname} src={option?.user_img ? option?.user_img : option?.user?.user_img} />}
                                        label={option.fullname ? option.fullname : option.user.fullname}
                                        {...getTagProps({ index })}
                                    />
                                ))
                            }
                            renderOption={(props, option) => {
                                return (
                                    <MenuItem {...props}>
                                        <CmtAvatar size={40} src={props?.user_img ? props?.user_img : props?.user?.user_img} alt={props?.fullname ? props?.fullname : props?.user?.fullname} variant="rounded" />
                                        <ListItemText primary={props?.fullname ? props?.fullname : props?.user?.fullname} style={{ marginRight: 7 }} />
                                    </MenuItem>
                                );
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Autocomplete
                            multiple
                            id="writers-autocomplete"
                            options={professionProfile}
                            getOptionLabel={option => option.fullname ? option.fullname : option.user.fullname}
                            value={selectedWriters}
                            onChange={(event, newValue) => {
                                setSelectedWriters(newValue);
                            }}
                            onInputChange={(event, newInputValue) => handleSearchProfessions(newInputValue)}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    label="انتخاب نویسندگان"
                                    placeholder="نویسندگان"
                                />
                            )}
                            renderTags={(value, getTagProps) =>
                                value.map((option, index) => (
                                    <Chip
                                        key={index}
                                        avatar={<Avatar alt={option.fullname ? option.fullname : option.user.fullname} src={option.user_img ? option?.user_img : option?.user?.user_img} />}
                                        label={option.fullname ? option.fullname : option.user.fullname}
                                        {...getTagProps({ index })}
                                    />
                                ))
                            }
                            renderOption={(props, option) => {
                                return (
                                    <MenuItem {...props}>
                                        <CmtAvatar size={40} src={props?.user_img ? props?.user_img : props?.user?.user_img} alt={props?.fullname ? props?.fullname : props?.user?.fullname} variant="rounded" />
                                        <ListItemText primary={props?.fullname ? props?.fullname : props?.user?.fullname} style={{ marginRight: 7 }} />
                                    </MenuItem>
                                );
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Autocomplete
                            multiple
                            id="producers-autocomplete"
                            options={professionProfile}
                            getOptionLabel={option => option.fullname ? option.fullname : option.user.fullname}
                            value={selectedProducers}
                            onChange={(event, newValue) => {
                                setSelectedProducers(newValue);
                            }}
                            onInputChange={(event, newInputValue) => handleSearchProfessions(newInputValue)}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    label="انتخاب تهیه کنندگان"
                                    placeholder="تهیه کنندگان"
                                />
                            )}
                            renderTags={(value, getTagProps) =>
                                value.map((option, index) => (
                                    <Chip
                                        key={index}
                                        avatar={<Avatar alt={option.fullname ? option.fullname : option.user.fullname} src={option?.user_img ? option?.user_img : option?.user?.user_img} />}
                                        label={option.fullname ? option.fullname : option.user.fullname}
                                        {...getTagProps({ index })}
                                    />
                                ))
                            }
                            renderOption={(props, option) => {
                                return (
                                    <MenuItem {...props}>
                                        <CmtAvatar size={40} src={props?.user_img ? props?.user_img : props?.user?.user_img} alt={props?.fullname ? props?.fullname : props?.user?.fullname} variant="rounded" />
                                        <ListItemText primary={props?.fullname ? props?.fullname : props?.user?.fullname} style={{ marginRight: 7 }} />
                                    </MenuItem>
                                );
                            }}
                        />
                    </Grid>
                </GridContainer>
                <Divider style={{ marginBottom: 20, marginTop: 20 }} />
                <Typography variant='h4' style={{ marginBottom: 10 }}>عوامل دگیر</Typography>
                <GridContainer>
                    {selectedOthers.map((value, index) => (
                        <Grid key={index} item xs={12} sm={12}>
                            <div style={{ display: "flex" }}>
                                <Autocomplete
                                    style={{ marginLeft: 20 }}
                                    fullWidth
                                    options={professions}
                                    getOptionLabel={(option) => option.name}
                                    value={value.profession}
                                    onChange={(event, newValue) => handleChangeOtherCasts(index, 'profession', newValue)}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            variant="outlined"
                                            label="نوع فعالیت"
                                        />
                                    )}
                                />
                                <Autocomplete
                                    fullWidth
                                    id="casts-autocomplete"
                                    options={professionProfile}
                                    getOptionLabel={option => option?.fullname ? option?.fullname : option?.user?.fullname}
                                    value={value.user}
                                    onChange={(event, newValue) => handleChangeOtherCasts(index, 'user', newValue)}
                                    onInputChange={(event, newInputValue) => handleSearchProfessions(newInputValue)}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            variant="outlined"
                                            label="نام عوامل"
                                            placeholder="نام عوامل"
                                        />
                                    )}
                                    renderOption={(props, option) => {
                                        return (
                                            <MenuItem {...props}>
                                                <CmtAvatar size={40} src={props?.user_img ? props?.user_img : props?.user?.user_img} alt={props?.fullname ? props?.fullname : props?.user?.fullname} variant="rounded" />
                                                <ListItemText primary={props?.fullname ? props?.fullname : props?.user?.fullname} style={{ marginRight: 7 }} />
                                            </MenuItem>
                                        );
                                    }}
                                />
                            </div>
                        </Grid>
                    ))}
                </GridContainer>
                <Button
                    style={{ marginTop: 5 }}
                    color="primary"
                    onClick={handleAddField}>
                    عوامل دیگر +
                </Button>
                <Box display="flex" justifyContent="space-between" mb={4} mt={4}>
                    <Box>
                        <Button
                            disabled={uploadLoading}
                            variant="contained"
                            color="primary"
                            style={{ marginLeft: 4 }}
                            onClick={handleSubmit}>
                            {movieInfo ? "ثبت تغییرات" : "ثبت کردن"}
                        </Button>
                        {
                            movieInfo &&
                            <Button
                                variant="contained"
                                color={"secondary"}
                                onClick={handleDelete}>
                                حذف فیلم
                            </Button>
                        }
                    </Box>
                    {
                        movieInfo &&
                        <Box style={{ display: "flex", minWidth: 200 }}>
                            <TextField
                                type='number'
                                variant='outlined'
                                label="تعداد بین  1 تا 100"
                                fullWidth
                                value={duplicateNumber}
                                inputProps={{ min: 1, max: 100 }}
                                onChange={(e) => setDuplicateNumber(e.target.value)}
                            />
                            <Button
                                variant='contained'
                                size='large'
                                color='primary'
                                startIcon={<FileCopyTwoTone />}
                                onClick={() => handleDuplicateMovie()}
                            >
                                کپی
                            </Button>
                        </Box>
                    }
                </Box>
            </Card>
        </React.Fragment>
    );
};

export default CreateRootMovieForm;
